
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
:host {
  font-family: var(--slh-default-font-family, "Open Sans");
  display: inline-flex;
  vertical-align: top;
  text-transform: uppercase;
  fill: var(--slh-color-neutral-shade-40, #C0C8D8);
}
:host .slh-avatar {
  display: inline-flex;
}
:host .slh-avatar slh-icon {
  outline: none;
  display: inline-flex;
}
:host .slh-avatar .avatar {
  outline: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: var(--slh-base-bold-font-weight, 700);
  color: var(--slh-color-neutral-shade-00, #FFFFFF);
}
:host .slh-avatar .avatar.avatar-image {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-color: transparent;
}
:host .slh-avatar {
  font-size: var(--slh-base-xs-font-size, 14px);
}
:host .slh-avatar .avatar, :host .slh-avatar .slh-icon {
  width: 40px;
  height: 40px;
}

:host([size=sm]) .slh-avatar {
  font-size: var(--slh-base-xxs-font-size, 12px);
}
:host([size=sm]) .slh-avatar .avatar, :host([size=sm]) .slh-avatar slh-icon {
  width: 24px;
  height: 24px;
}

:host([size=md]) .slh-avatar {
  font-size: var(--slh-base-xs-font-size, 14px);
}
:host([size=md]) .slh-avatar .avatar, :host([size=md]) .slh-avatar .slh-icon {
  width: 40px;
  height: 40px;
}

:host([size=lg]) .slh-avatar {
  font-size: var(--slh-base-l-font-size, 18px);
}
:host([size=lg]) .slh-avatar .avatar, :host([size=lg]) .slh-avatar slh-icon {
  width: 64px;
  height: 64px;
}

@media (min-width: 560px) {
  :host([size-sm=sm]) .slh-avatar {
    font-size: var(--slh-base-xxs-font-size, 12px);
  }
  :host([size-sm=sm]) .slh-avatar .avatar, :host([size-sm=sm]) .slh-avatar slh-icon {
    width: 24px;
    height: 24px;
  }
  :host([size-sm=md]) .slh-avatar {
    font-size: var(--slh-base-xs-font-size, 14px);
  }
  :host([size-sm=md]) .slh-avatar .avatar, :host([size-sm=md]) .slh-avatar .slh-icon {
    width: 40px;
    height: 40px;
  }
  :host([size-sm=lg]) .slh-avatar {
    font-size: var(--slh-base-l-font-size, 18px);
  }
  :host([size-sm=lg]) .slh-avatar .avatar, :host([size-sm=lg]) .slh-avatar slh-icon {
    width: 64px;
    height: 64px;
  }
}
@media (min-width: 768px) {
  :host([size-md=sm]) .slh-avatar {
    font-size: var(--slh-base-xxs-font-size, 12px);
  }
  :host([size-md=sm]) .slh-avatar .avatar, :host([size-md=sm]) .slh-avatar slh-icon {
    width: 24px;
    height: 24px;
  }
  :host([size-md=md]) .slh-avatar {
    font-size: var(--slh-base-xs-font-size, 14px);
  }
  :host([size-md=md]) .slh-avatar .avatar, :host([size-md=md]) .slh-avatar .slh-icon {
    width: 40px;
    height: 40px;
  }
  :host([size-md=lg]) .slh-avatar {
    font-size: var(--slh-base-l-font-size, 18px);
  }
  :host([size-md=lg]) .slh-avatar .avatar, :host([size-md=lg]) .slh-avatar slh-icon {
    width: 64px;
    height: 64px;
  }
}
@media (min-width: 992px) {
  :host([size-lg=sm]) .slh-avatar {
    font-size: var(--slh-base-xxs-font-size, 12px);
  }
  :host([size-lg=sm]) .slh-avatar .avatar, :host([size-lg=sm]) .slh-avatar slh-icon {
    width: 24px;
    height: 24px;
  }
  :host([size-lg=md]) .slh-avatar {
    font-size: var(--slh-base-xs-font-size, 14px);
  }
  :host([size-lg=md]) .slh-avatar .avatar, :host([size-lg=md]) .slh-avatar .slh-icon {
    width: 40px;
    height: 40px;
  }
  :host([size-lg=lg]) .slh-avatar {
    font-size: var(--slh-base-l-font-size, 18px);
  }
  :host([size-lg=lg]) .slh-avatar .avatar, :host([size-lg=lg]) .slh-avatar slh-icon {
    width: 64px;
    height: 64px;
  }
}
@media (min-width: 1200px) {
  :host([size-xl=sm]) .slh-avatar {
    font-size: var(--slh-base-xxs-font-size, 12px);
  }
  :host([size-xl=sm]) .slh-avatar .avatar, :host([size-xl=sm]) .slh-avatar slh-icon {
    width: 24px;
    height: 24px;
  }
  :host([size-xl=md]) .slh-avatar {
    font-size: var(--slh-base-xs-font-size, 14px);
  }
  :host([size-xl=md]) .slh-avatar .avatar, :host([size-xl=md]) .slh-avatar .slh-icon {
    width: 40px;
    height: 40px;
  }
  :host([size-xl=lg]) .slh-avatar {
    font-size: var(--slh-base-l-font-size, 18px);
  }
  :host([size-xl=lg]) .slh-avatar .avatar, :host([size-xl=lg]) .slh-avatar slh-icon {
    width: 64px;
    height: 64px;
  }
}
@media (min-width: 1400px) {
  :host([size-xxl=sm]) .slh-avatar {
    font-size: var(--slh-base-xxs-font-size, 12px);
  }
  :host([size-xxl=sm]) .slh-avatar .avatar, :host([size-xxl=sm]) .slh-avatar slh-icon {
    width: 24px;
    height: 24px;
  }
  :host([size-xxl=md]) .slh-avatar {
    font-size: var(--slh-base-xs-font-size, 14px);
  }
  :host([size-xxl=md]) .slh-avatar .avatar, :host([size-xxl=md]) .slh-avatar .slh-icon {
    width: 40px;
    height: 40px;
  }
  :host([size-xxl=lg]) .slh-avatar {
    font-size: var(--slh-base-l-font-size, 18px);
  }
  :host([size-xxl=lg]) .slh-avatar .avatar, :host([size-xxl=lg]) .slh-avatar slh-icon {
    width: 64px;
    height: 64px;
  }
}
:host .slh-avatar .avatar {
  background-color: var(--slh-color-primary-shade-40, #DAECFF);
  color: var(--slh-color-neutral-shade-00, #FFFFFF);
}

:host([size=xl]) .slh-avatar {
  font-size: var(--slh-base-xxl-font-size, 32px);
}
:host([size=xl]) .slh-avatar .avatar, :host([size=xl]) .slh-avatar slh-icon {
  width: 120px;
  height: 120px;
}

@media (min-width: 560px) {
  :host([size-sm=xl]) .slh-avatar {
    font-size: var(--slh-base-xxl-font-size, 32px);
  }
  :host([size-sm=xl]) .slh-avatar .avatar, :host([size-sm=xl]) .slh-avatar slh-icon {
    width: 120px;
    height: 120px;
  }
}
@media (min-width: 768px) {
  :host([size-md=xl]) .slh-avatar {
    font-size: var(--slh-base-xxl-font-size, 32px);
  }
  :host([size-md=xl]) .slh-avatar .avatar, :host([size-md=xl]) .slh-avatar slh-icon {
    width: 120px;
    height: 120px;
  }
}
@media (min-width: 992px) {
  :host([size-lg=xl]) .slh-avatar {
    font-size: var(--slh-base-xxl-font-size, 32px);
  }
  :host([size-lg=xl]) .slh-avatar .avatar, :host([size-lg=xl]) .slh-avatar slh-icon {
    width: 120px;
    height: 120px;
  }
}
@media (min-width: 1200px) {
  :host([size-xl=xl]) .slh-avatar {
    font-size: var(--slh-base-xxl-font-size, 32px);
  }
  :host([size-xl=xl]) .slh-avatar .avatar, :host([size-xl=xl]) .slh-avatar slh-icon {
    width: 120px;
    height: 120px;
  }
}
@media (min-width: 1400px) {
  :host([size-xxl=xl]) .slh-avatar {
    font-size: var(--slh-base-xxl-font-size, 32px);
  }
  :host([size-xxl=xl]) .slh-avatar .avatar, :host([size-xxl=xl]) .slh-avatar slh-icon {
    width: 120px;
    height: 120px;
  }
}
`;
